import React, { useCallback, useMemo } from 'react'
import Group from 'components/utils/Group'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import CardCarousel from 'components/Luxkit/Carousel/CardCarousel'
import TextButton from 'components/Luxkit/Button/TextButton'
import { pluralizeToString } from 'lib/string/pluralize'
import HomesVillasMiniTileContainer from 'components/Pages/HotelSearchPage/OfferMiniTile/HomesVillasMiniTileContainer'
import { getSearchQueryFromFilter } from 'lib/search/searchUtils'
import styled from 'styled-components'
import { mediaQueryDown } from 'components/utils/breakpoint'
import { rem } from 'polished'
import { track } from 'analytics/analytics'
import { clientEvent } from 'analytics/snowplow/events'

const Container = styled(Group)`
  padding-bottom: ${rem(8)};

  ${mediaQueryDown.mobile} {
    padding-left: ${rem(16)};
    background-color: ${props => props.theme.palette.neutral.default.eight};
  }
`

interface Props {
  filters: App.OfferListFilters;
  offerList: App.OfferList;
  destinationName: string;
}

function HotelSearchHomesVillasCarousel({
  filters,
  offerList,
  destinationName,
}: Props) {
  const to = useMemo(() => {
    return `/search/homes-and-villas?${getSearchQueryFromFilter({
      ...filters,
      destinationName,
    })}`
  }, [destinationName, filters])

  const onClickViewAll = useCallback(() => {
    track('client-event', clientEvent({
      subject: 'View All',
      action: 'clicked_view_all',
      category: 'villa_carousel',
      type: 'interaction',
    }))
  }, [])

  const onClickTile = useCallback(() => {
    track('client-event', clientEvent({
      subject: destinationName,
      action: 'clicked_tile',
      category: 'villa_carousel',
      type: 'interaction',
    }))
  }, [destinationName])

  return (
    <Container direction="vertical" gap={8}>
      <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center">
        <BodyTextBlock variant="large">
          Homes and Villas in {destinationName}
        </BodyTextBlock>
        <TextButton kind="tertiary" to={to} onClick={onClickViewAll}>
          View {pluralizeToString('offer', offerList.offerCount!)}
        </TextButton>
      </Group>
      <CardCarousel gap={16}>
        {offerList.offerIds.map((offerId) => (
          <HomesVillasMiniTileContainer
          offerId={offerId}
          filters={filters}
          onClick={onClickTile}
          key={offerId}
        />
        ))}
      </CardCarousel>
    </Container>
  )
}

export default HotelSearchHomesVillasCarousel
